"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slide = exports.SlideList = exports.Track = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "ftfs3s-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    position: relative;\n    flex-direction: column;\n"])));

exports.Wrapper = Wrapper;

var Track = _styledComponents["default"].div.withConfig({
  displayName: "styled__Track",
  componentId: "ftfs3s-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    display: block;\n    overflow: ", ";\n    white-space: nowrap;\n    padding-bottom: 64px;\n    z-index: 2;\n    @media(max-width: ", ") {\n        overflow: visible;\n    }\n    ", "\n"])), function (p) {
  return p.showTransparent ? 'visible' : 'hidden';
}, function (_ref) {
  var visibleCardWidth = _ref.visibleCardWidth;
  return visibleCardWidth ? visibleCardWidth + 'px' : '0';
}, function (p) {
  return p.customStyles ? p.customStyles : '';
});

exports.Track = Track;

var SlideList = _styledComponents["default"].div.withConfig({
  displayName: "styled__SlideList",
  componentId: "ftfs3s-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: ", ";\n    justify-content: ", ";\n    cursor: grab;\n    height: 100%;\n    touch-action: none;\n"])), function (props) {
  return props.isSlider || props.vertical ? 'block' : 'flex';
}, function (props) {
  return props.align;
});

exports.SlideList = SlideList;

var Slide = _styledComponents["default"].div.withConfig({
  displayName: "styled__Slide",
  componentId: "ftfs3s-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: ", ";\n    ", ": ", "%;\n    outline: none;\n    opacity: ", ";\n    ", "\n"])), function (_ref2) {
  var vertical = _ref2.vertical;
  return vertical ? 'block' : 'inline-block';
}, function (_ref3) {
  var vertical = _ref3.vertical;
  return vertical ? 'height' : 'width';
}, function (props) {
  return props.scale;
}, function (p) {
  return p.isTransparent ? '0.2' : '1';
}, function (p) {
  return p.customStyles ? p.customStyles : '';
});

exports.Slide = Slide;